<template>
    <div class="overflow-x-hidden">
        <section
            class="contact-section  grid  py-4  flex justify-content-center align-items-center ">
            <div class="container px-4 md:px-6 text-center col-12 md:col-6">
                <div class="contact-card relative overflow-hidden shadow-2 border-round-md">
                    <div class="relative z-1 text-center px-4 md:px-8 py-8 md:py-10 ">
                        <h2 class="H5-SemiBold mb-3 ">Still have questions?</h2>
                        <p class="Paragraph-Regular mx-auto">
                            Reach out and ride the ILearn'd wave - contact us today!
                        </p>
                        <Button label="Get in touch" icon="pi pi-arrow-right" iconPos="right"
                            class="community-button" 
                            @click="$router.push('/aboutUs#contact-us')"
                            />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import Button from 'primevue/button';
</script>